import React from "react";
import { Toaster, Position } from "@blueprintjs/core";
import RandomString from "randomstring";
import { storage } from "../../fire";

import {
    toast_deleteError,
    toast_deleteSuccess,
    toast_uploadError,
    toast_uploadInProgress,
    toast_uploadSuccess,
    toast_warningError
} from "./Sequences/Toast";
import Auth from "../../services/Auth";
import DialogAddConclusion from "./Conclusions/DialogAddConclusion";
import CreatePanelConclusionTable from "./Conclusions/TableConclusion";
import Session from "../../services/Session";

class CreatePanelConclusion extends React.Component {
    toaster; // React Reference to Toaster component

    constructor(props) {
        super(props);
        this.state = {
            dialogIsOpen: false,
            conclusion: {
                name: null,
                file: null,
                fileInternalName: null,
                fileBlob: null,
                downloadURL: null,
                type: null
            },
            isDeletingConclusion: false
        };
        this.storageBaseRef = "";
    }

    handleOpenDialog = () => this.setState({ dialogIsOpen: true });
    handleCloseDialog = () => this.setState({ dialogIsOpen: false });

    handleChangeInput = e => {
        const name = e.target.name;
        const value = e.target.value;
        const { conclusion } = this.state;

        this.setState({ conclusion: { ...conclusion, [name]: value } });
    };

    handleChangeFileInput = e => {
        const name = e.target.name;
        const blob = e.target.files[0] || null;
        let value = e.target.value;
        const { conclusion } = this.state;

        // Get only the file name from the full path
        value = value.replace(/^.*[\\/]/, "");
        this.setState({
            conclusion: { ...conclusion, [name]: value, fileBlob: blob }
        });
    };

    handleConclusion = () => {
        this.setState({ submiting: true });

        const { onChangeConclusion, conclusions, sessionId } = this.props;
        const { conclusion } = this.state;
        const uploadToastKey = this.toaster.show(toast_uploadInProgress(0));
        conclusion.fileInternalName = RandomString.generate(30);
        const storageRef = Session.addConclusion({
            sessionId,
            conclusion,
            onProgress: snapshot => {
                /**
                 * Upload is in progress
                 * --
                 * Calculate purcentage of uploading
                 * Update the upload toast with the new purcentage
                 */
                let progress = Math.round(
                    (snapshot.bytesTransferred / snapshot.totalBytes) * 100
                );

                this.toaster.show(toast_uploadInProgress(progress), uploadToastKey);
            },
            onError: e => {
                /**
                 * Upload has errored
                 * --
                 * Set the new state (no more submiting and interlude obj is reseted)
                 * Close the 'Ajouter un interlude' dialog
                 * Dismiss the upload toast
                 * Show an error toast
                 */
                this.setState({
                    submiting: false,
                    interlude: {
                        name: null,
                        file: null,
                        fileInternalName: null,
                        fileBlob: null,
                        downloadURL: null,
                        type: null
                    }
                });
                this.handleCloseDialog();
                this.toaster.dismiss(uploadToastKey);
                this.toaster.show(toast_uploadError());
                console.error("An error has been occured when uploading\n", e.message);
            },
            onComplete: () => {
                /**
                 * Upload is complete
                 * --
                 * Give an id to the interlude (usefull for interlude removing)
                 * Get the download URL of the uploaded file (async)
                 * Push the interlude to the list of interludes (omit the fileBlob attribute)
                 * Call prop handler 'onChangeConclusion' to update the list of interlude of the parent component
                 * Set the new state (update list of interlude, no more submiting and interlude obj is reseted)
                 * Dismiss the upload toast
                 * Show a success toast
                 */
                storageRef
                    .getDownloadURL()
                    .then(url => (conclusion.downloadURL = url))
                    .then(() => {
                        conclusions.push({
                            id: RandomString.generate(16),
                            name: conclusion.name,
                            file: conclusion.file,
                            fileInternalName: conclusion.fileInternalName,
                            downloadURL: conclusion.downloadURL,
                            type: conclusion.type
                        });
                        onChangeConclusion(conclusions);
                        this.setState({
                            submiting: false,
                            conclusion: {
                                name: null,
                                file: null,
                                fileInternalName: null,
                                fileBlob: null,
                                downloadURL: null,
                                type: null
                            }
                        });
                        this.handleCloseDialog();
                        this.toaster.dismiss(uploadToastKey);
                        this.toaster.show(toast_uploadSuccess());
                    });
            }
        });
    };

    handleDeleteConclusion = id => {
        let { conclusions } = this.props;
        const { onChangeConclusion, sessionId } = this.props;
        const storageRef = storage.ref(
            `${this.storageBaseRef}/${sessionId}/${conclusions.find(i => i.id === id).fileInternalName
            }`
        );
        const deleteConclusion = () => {
            // Delete the element that has the given id using Array.filter
            conclusions = conclusions.filter(i => i.id !== id);
            onChangeConclusion(conclusions);
        };

        this.setState({ isDeletingConclusion: true });
        storageRef
            .delete()
            .then(() => {
                this.toaster.show(toast_deleteSuccess());
                deleteConclusion();
                this.setState({ isDeletingConclusion: false });
            })
            .catch(e => {
                const { code } = e;

                this.setState({ isDeletingConclusion: false });
                switch (code) {
                    case "storage/unknown":
                        this.toaster.show(
                            toast_deleteError("Unknow error occurred...")
                        );
                        break;
                    case "storage/object-not-found":
                        this.toaster.show(
                            toast_warningError(
                                "The interlude file was not found, we still deleted the interlude.",
                                10000
                            )
                        );
                        deleteConclusion();
                        break;
                    case "storage/quota-exceeded":
                        this.toaster.show(
                            toast_deleteError("Allocated storage space is full.")
                        );
                        break;
                    case "storage/unauthenticated":
                        this.toaster.show(
                            toast_deleteError("Please login !")
                        );
                        break;
                    default:
                        this.toaster.show(toast_deleteError(e.message));
                        break;
                }
            });
    };

    handleChangeOrder = (currentIndex, newIndex) => {
        let { onChangeConclusion, conclusions = [] } = this.props;

        conclusions.splice(newIndex, 0, conclusions.splice(currentIndex, 1)[0]);
        onChangeConclusion(conclusions);
    };

    render() {
        const { conclusions } = this.props;
        const {
            dialogIsOpen,
            submiting,
            conclusion,
            isDeletingConclusion
        } = this.state;

        return (
            <div>
                <Toaster
                    position={Position.TOP_RIGHT}
                    autoFocus={false}
                    ref={toaster => (this.toaster = toaster)}
                />
                <DialogAddConclusion
                    conclusion={conclusion}
                    dialogIsOpen={dialogIsOpen}
                    submiting={submiting}
                    onCloseDialog={this.handleCloseDialog}
                    onChangeInput={this.handleChangeInput}
                    onChangeInputFile={this.handleChangeFileInput}
                    onAddInterlude={this.handleConclusion}
                />
                <CreatePanelConclusionTable
                    conclusions={conclusions}
                    deleting={isDeletingConclusion}
                    onDeleteConclusion={this.handleDeleteConclusion}
                    onChangeOrder={this.handleChangeOrder}
                    onOpenDialog={this.handleOpenDialog}
                />
            </div>
        );
    }

    componentDidMount() {
        this.storageBaseRef = `conclusions/${Auth.getUserId()}`;
    }
}

export default CreatePanelConclusion;
